import { Tooltip, Skeleton } from "@mui/material";
import { OrderType } from "../../../../explorer/types/Basket/OrderType";
import {
    AppIconsOrderTypeSell,
    AppIconsOrderTypeService,
} from "../../AppIcons";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";

type TOrderTypeIconComponent = {
    item: any;
};

const OrderTypeIcon = (status: string | "") => {
    const enumValue = Object.values(OrderType).find(
        (value) => value === status
    );
    switch (enumValue) {
        case OrderType.Sales:
            return <AppIconsOrderTypeSell/>;
        case OrderType.Service:
            return <AppIconsOrderTypeService />;
        default:
            return <></>;
    }
};

const OrderTypeIconComponent = (props: TOrderTypeIconComponent) => {
    const type = props.item.orderType;
    const { t } = useTranslation();

    let orderTypeTooltipTitle = t(`offerOrder.${type.replace(/\s+/g, "")}`);
    if (type === OrderType.Service) {
        orderTypeTooltipTitle += ` - ${props.item.warrantyOrderType}`;
    }
    return (
        <>
            {type ? (
                <Tooltip
                    children={OrderTypeIcon(type)}
                    title={orderTypeTooltipTitle}
                    placement="top"
                    disableInteractive
                />
            ) : (
                <Skeleton variant="circular" width={20} height={20} />
            )}
        </>
    );
};

export default OrderTypeIconComponent;
